import { Middleware } from "@reduxjs/toolkit";

import { logout, setUserToken } from "./auth-slice";

export const authMiddleware: Middleware = () => (next) => (action) => {
  if (setUserToken.match(action)) {
    const accessToken = action.payload;
    if (accessToken) {
      localStorage.setItem("accessToken", accessToken);
    }
  } else if (logout.match(action)) {
    localStorage.removeItem("accessToken");
  }

  return next(action);
};
